"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "sessano-del-molise": {
    "1f8a5db9": [{
      "hkey": "90e7666b",
      "slug": "sessano-del-molise",
      "name": "Sessano del Molise",
      "primary": true,
      "skipSearch": false
    }],
    "durante": [{
      "hkey": "90e7666b",
      "slug": "sessano-del-molise",
      "name": "Sessano del Molise",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "5db11fdf": [{
      "hkey": "90e7666b",
      "slug": "sessano-del-molise",
      "name": "Sessano del Molise",
      "primary": true,
      "skipSearch": false
    }],
    "pantaniello": [{
      "hkey": "90e7666b",
      "slug": "sessano-del-molise",
      "name": "Sessano del Molise",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "8b77e316": [{
      "hkey": "90e7666b",
      "slug": "sessano-del-molise",
      "name": "Sessano del Molise",
      "primary": true,
      "skipSearch": false
    }],
    "pescocupo": [{
      "hkey": "90e7666b",
      "slug": "sessano-del-molise",
      "name": "Sessano del Molise",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;